import { Injectable } from '@angular/core';
import { UserDetails } from '../schema/user-details';
import { Raffle } from '../schema/raffle';

@Injectable({
  providedIn: 'root'
})
export class RaffleCartService {

  totalTickets = 0;
  grandTotal = 0;
  userDetails: UserDetails;

  constructor() {
  }


  buyFirstItem(tierId: number) {
    this.clearCart();
    const tier = Raffle.currentRaffle.pricingTiers.find(t => t.pricingTierId === tierId);
    tier.qtyInCart = 1;
    this.modifyItem(tierId, 0);
  }

  modifyItem(tierId: number, qtyAdj: number) {
    const tier = Raffle.currentRaffle.pricingTiers.find(t => t.pricingTierId === tierId);

    if (qtyAdj === 1) {
      tier.qtyInCart++;
    } else if (qtyAdj === -1) {
      tier.qtyInCart--;
    }

    this.refreshCartTotals();
  }

  clearCart() {
    this.totalTickets = 0;
    this.grandTotal = 0;
    Raffle.currentRaffle.pricingTiers.forEach(t => {
      t.qtyInCart = 0;
    });
  }

  refreshCartTotals() {
    this.totalTickets = Raffle.currentRaffle.pricingTiers.reduce((a, b) => a + b.ticketQuantity * b.qtyInCart, 0);
    this.grandTotal = Raffle.currentRaffle.pricingTiers.reduce((a, b) => a + b.price * b.qtyInCart, 0);
  }
}
